import o from"styled-components";const e=o.input`
	padding: 4px 8px;
	height: 40px;
	background-color: ${({theme:o})=>o.bg.primary};
	border-radius: 8px;
	box-sizing: border-box;
	border: none;
	width: 100%;

	&:focus {
		outline: ${({theme:o})=>`2px solid ${o.text.brand}4d`};
		outline-offset: 1px;
		background-color: ${({theme:o})=>o.bg.general};
	}
`;export{e as TextContainer};
